import { render } from "./ManageGames.vue?vue&type=template&id=2a90adfa&scoped=true"
import script from "./ManageGames.vue?vue&type=script&lang=js"
export * from "./ManageGames.vue?vue&type=script&lang=js"

import "./ManageGames.vue?vue&type=style&index=0&id=2a90adfa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a90adfa"]])

export default __exports__